module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-glitter_line.512a7bc6.png";